var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import IconWASD from "@/public_assets/instructions/WASD.svg";
import { useKeyboardLayout } from "@/utils/arrowsControls";
import classNames from "classnames";
import React from "react";
import styles from "./WASDLayout.module.scss";
export var WASDLayout = function () {
    var letters = useKeyboardLayout();
    return (React.createElement("div", { className: styles.layout },
        React.createElement(IconWASD, null),
        Object.entries(letters).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            return (React.createElement("span", { key: key, className: classNames(styles.letter, styles[key]) }, value));
        })));
};
